import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* List Bonus Rounds */
export const list = ({ page = 1, search = "", operators = "", tables = "", start = "", end = "", result = "", pool = "", testers = true, vips = true }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, timezone: utils.getTimezone() })

    if (search) params.set("search", search)
    if (operators) params.set("operators", operators)
    if (tables) params.set("tables", tables)
    if (start) params.set("start", start)
    if (end) params.set("end", end)
    if (result) params.set("result", result)
    if (pool) params.set("pool", pool)
    if (!testers) params.set("testers", "0")
    if (!vips) params.set("vips", "0")

    /* Send Request */
    const uri = `${env.startpoint}bonus/list?${params.toString()}`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section (операторы и игры — строго в рамках доступа токена) */
export const filters = () => {

    const uri = `${env.startpoint}bonus/filters`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }

    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Bonus Operators */
export const bonus = () => {
    const uri = `${env.startpoint}bonus/bonus`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}


/* Bonus Update */
export const update = (data) => {
    const uri = `${env.startpoint}bonus/update`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}

/* Bonus Operators */
export const operators = () => {
    const uri = `${env.startpoint}bonus/operators`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then((response) => response).catch((data) => data.response)
}

/* Bonus Connect */
export const connect = (data) => {
    const uri = `${env.startpoint}bonus/connect`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then((response) => response).catch((data) => data.response)
}
